import { render, staticRenderFns } from "./ImporvementPlans3.vue?vue&type=template&id=8363124c&"
import script from "./ImporvementPlans3.vue?vue&type=script&lang=js&"
export * from "./ImporvementPlans3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports